import { Box, Card, Grid, Modal, Typography } from "@mui/material";
import MDButton from "components/MDButton";

import PersonOffIcon from "@mui/icons-material/PersonOff";
import AutoDeleteIcon from "@mui/icons-material/AutoDelete";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  p: 4,
  display: "grid",
  justifyContent: "center",
};

function DeactiveDeleteModal({ ...props }) {
  return (
    <Modal
      open={props.open}
      onClose={props.handleClose}
      disableEscapeKeyDown
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Card sx={style}>
        <Box>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            style={{ fontSize: "40px", textAlign: "center" }}
          >
            {props.icon === "Delete" ? (
              <AutoDeleteIcon style={{ color: "red" }} />
            ) : (
              <PersonOffIcon style={{ color: "#FB8C00" }} />
            )}
          </Typography>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            style={{ color: "black", textAlign: "center" }}
          >
            {`${props.title}`}
          </Typography>
          <Typography
            id="modal-modal-description"
            sx={{ mt: 2, fontSize: 12, textAlign: "center" }}
          >
            {`${props.message}`}
          </Typography>
          {props.notes && (
            <Typography
              id="modal-modal-description"
              sx={{ mt: 2, fontSize: 11, textAlign: "center", color: "red" }}
            >
              {props.notes}
            </Typography>
          )}
          <Grid
            container
            id="modal-modal-description"
            sx={{ mt: 2, justifyContent: "center" }}
          >
            <MDButton
              className="modalButton no-button"
              onClick={props.handleClose}
              style={{ width: "64px", textTransform: "capitalize" }}
            >
              Cancel
            </MDButton>
            &nbsp; &nbsp;
            <MDButton
              className="modalButton yes-button"
              onClick={props.handleConfirm}
              style={{ width: "64px", textTransform: "capitalize" }}
            >
              Confirm
            </MDButton>
          </Grid>
        </Box>
      </Card>
    </Modal>
  );
}

export default DeactiveDeleteModal;
